import React from "react";
import { Sparkles } from "lucide-react";

/**
 * GuideAskAI — Box AI istituzionale (Foundation, riutilizzabile).
 *
 * Componente Foundation della Suite: mostra un messaggio informativo finche'
 * l'Assistente non e' abilitato. Quando arrivera' la release funzionale
 * bastera' passare `enabled={true}` e sostituire il body con l'input di
 * conversazione: posizione, layout, testata e stile restano immutati.
 *
 * Endpoint backend `/api/guide/ai/ask` restituisce 501 in Consegna 1.
 *
 * Props:
 *   - enabled?: boolean (default false) → in futuro attiva la UI di chat.
 *   - title?: string (default istituzionale).
 *   - message?: string (default istituzionale).
 */
const DEFAULT_TITLE = "Assistente AI di Gruppo Impresa Suite";
const DEFAULT_MESSAGE = `Stiamo realizzando un assistente intelligente integrato che ti aiutera' nell'utilizzo della Suite, nella ricerca delle procedure, nell'interpretazione delle funzionalita' e nelle attivita' operative quotidiane. La funzionalita' sara' resa disponibile in una prossima release.`;

export function GuideAskAI({ enabled = false, title = DEFAULT_TITLE, message = DEFAULT_MESSAGE }) {
  return (
    <section
      className="rounded-lg border border-dashed border-suite-primary/30 bg-suite-primary/5 p-4"
      data-testid="guide-ask-ai"
      aria-live="polite"
    >
      <div className="mb-1 flex items-center gap-2">
        <Sparkles size={14} className="text-suite-primary" />
        <h3 className="text-xs font-bold uppercase tracking-[0.14em] text-suite-primary">
          {title}
        </h3>
      </div>
      <p className="text-xs leading-relaxed text-suite-neutral-600" data-testid="guide-ask-ai-message">
        {message}
        {!enabled && (
          <>
            {" "}
            <span className="italic text-suite-neutral-400">
              (in fase di attivazione)
            </span>
          </>
        )}
      </p>
    </section>
  );
}
